export default "__VITE_ASSET__C2AYw$Bj__"